module.exports = "/call-frontend/img/icon_check_round_outline.7f5ab143.svg";